export default __webpack_public_path__ + "static/media/hht2_ep02_timeline_01.1a301cb8.png";